import _get from 'lodash/get';

import { objectToCamelCase } from '../../../../libs/format';

export function selectTeams(state) {
  return Object.values(objectToCamelCase(_get(state, 'teams.entities', []))) || [];
}
